"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paragraphSizeToListSize = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _NestedList = require("./NestedList");
var _List = require("../List/List");
var _getIcon = require("../utils/getIcon");
var _TypographyVariantTypes = require("./TypographyVariantTypes");
var _ThemeContext = require("../contexts/ThemeContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var paragraphSizeToListSize = exports.paragraphSizeToListSize = {
  micro: 'small',
  small: 'small',
  large: 'large',
  eyebrow: 'large'
};
var listTypes = {
  ol: _componentsWeb.OrderedList,
  ul: _componentsWeb.List
};
var RichTextList = _ref => {
  var {
    children,
    type = 'ul',
    size = 'medium',
    iconName,
    iconColor = 'purpleTelus',
    iconSize = 'medium',
    inverse = false
  } = _ref;
  var {
    themeName
  } = (0, _ThemeContext.useFormBuilderTheme)();
  if (!children) return;
  var List = listTypes[type];
  var IconComponent = type === 'ul' && iconName ? (0, _getIcon.getIcon)(iconName, themeName) : undefined;
  var iconProps = !!IconComponent ? {
    icon: IconComponent,
    iconColor: _TypographyVariantTypes.iconColors[iconColor],
    iconSize: (0, _List.getIconSize)(iconSize)
  } : null;
  if (inverse) {
    iconProps.iconColor = _TypographyVariantTypes.iconColors['white'];
  }
  var items;
  if (Array.isArray(children)) {
    items = children.flatMap(item => {
      return Array.isArray(item) && item.map((child, i) => {
        if (!child) return null;
        // TODO: replace this when nested lists are allow in UDS
        if (/*#__PURE__*/_react.default.isValidElement(child) && child.type === RichTextList) return /*#__PURE__*/_react.default.createElement(_NestedList.NestedList, {
          key: "nested-item-".concat(i)
        }, child);
        return /*#__PURE__*/_react.default.createElement(List.Item, _extends({
          key: "rich-unordered-list-item-".concat(i)
        }, iconProps), child);
      });
    });
  }
  return /*#__PURE__*/_react.default.createElement(List, {
    variant: {
      size
    }
  }, items);
};

// Lists should match text, so extra small should be allowed. Waiting UDS Fix
RichTextList.propTypes = {
  type: _propTypes.default.oneOf(['ol', 'ul']),
  size: _propTypes.default.oneOf(_TypographyVariantTypes.ListSize),
  iconName: _propTypes.default.string,
  iconColor: _propTypes.default.oneOf(_TypographyVariantTypes.IconColor),
  iconSize: _propTypes.default.oneOf(_TypographyVariantTypes.IconSize),
  children: _propTypes.default.node.isRequired
};
RichTextList.displayName = 'RichTextList';
var _default = exports.default = RichTextList;